import {loadUTMParams} from "../../utils/Referrer";

// What a merchant registers with the SDK: called with whatever the call site passes it, and its result
// is handed back to that caller. Declared here rather than next to the module that keeps the registry,
// which already imports this file - the other direction would be a cycle
export type MerchantFunction = (...args: any[]) => any;

export const merchantBuiltinFunctions: Record<string, MerchantFunction> = {};

// These will also be overwritten by the settings from the SDK initOptions
export const merchantBuiltinVariables: Record<string, any> = {
    "utm": loadUTMParams(),
};
